import {useEffect, useState} from "react";
import {PeerActivityHub, type PeerActivityListener, type Unsubscribe} from "core/p2p/peerActivity";

/** Both the live card and its offer placement read the same replaying activity source. */
export function usePeerActivity(subscribe: (listener: PeerActivityListener) => Unsubscribe) {
	const [activity, setActivity] = useState(() => new PeerActivityHub().snapshot());
	useEffect(() => subscribe(setActivity), [subscribe]);
	return activity;
}
